/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fraction Calculator (Add, Subtract, Multiply, Divide) — Toolverse`)
};

const es_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar y Reemplazar — Reemplazo de texto en lote (Regex) | Toolverse`)
};

const de_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen und Ersetzen — Text massenhaft ersetzen (Regex) | Toolverse`)
};

const nl_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken en vervangen — Bulktekstvervanging (Regex) | Toolverse`)
};

const fr_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chercher et Remplacer — Remplacement de texte en masse (Regex) | Toolverse`)
};

const it_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca e Sostituisci — Sostituzione di testo in massa (Regex) | Toolverse`)
};

const pt_br2_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localizar e Substituir — Substituição em massa de texto (Regex) | Toolverse`)
};

const pt_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar e Substituir — Substituir Texto em Massa (Regex) | Toolverse`)
};

const ja_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索と置換 — 一括テキスト置換（正規表現）| Toolverse`)
};

const zh_fr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查找和替换 — 批量文本替换（正则表达式）| Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_meta_title", locale)
	if (locale === "en") return en_fr_meta_title(inputs)
	if (locale === "es") return es_fr_meta_title(inputs)
	if (locale === "de") return de_fr_meta_title(inputs)
	if (locale === "nl") return nl_fr_meta_title(inputs)
	if (locale === "fr") return fr_fr_meta_title(inputs)
	if (locale === "it") return it_fr_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_fr_meta_title(inputs)
	if (locale === "pt") return pt_fr_meta_title(inputs)
	if (locale === "ja") return ja_fr_meta_title(inputs)
	return zh_fr_meta_title(inputs)
};